import { IMAGE_TYPE_UPLOAD } from '@/commons/constants';
import { RootState } from '@/redux/store';
import { FileModel, FileType } from '@/types';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { FC, useCallback, useEffect, useState } from 'react';
import { Accept } from 'react-dropzone';
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import StorageFileContent from '../../StorageFileContent';

type Props = {
  multiple?: boolean;
  value?: FileModel[];
  onSubmit?: (data: FileModel[]) => void;
  accept?: Accept;
  contentTypes?: FileType[];
};

const ExistedFilesModal: FC<Props> = (props: Props) => {
  const {
    value = [],
    onSubmit,
    multiple = true,
    accept = IMAGE_TYPE_UPLOAD.accept,
    contentTypes = IMAGE_TYPE_UPLOAD.contentType,
  } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const [selected, setSelected] = useState<FileModel[]>([]);

  const loading = useSelector((state: RootState) => state.storage.loading);

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = useCallback(() => {
    if (onSubmit) {
      const data = Object.values(selected).map((item) => {
        if (!item.uniqueId) {
          return {
            ...item,
            uniqueId: uuidv4(),
          };
        }
        return item;
      });
      onSubmit(data);
    }
    setVisible(false);
  }, [selected]);

  const handleCancel = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (visible) {
      setSelected(value || []);
    }
  }, [visible]);

  const operations = (
    <>
      <Button
        key="submit"
        type="primary"
        disabled={loading}
        onClick={handleOk}
        style={{ marginRight: 5 }}
      >
        Submit
      </Button>
      <Button key="back" disabled={loading} onClick={handleCancel}>
        Cancel
      </Button>
    </>
  );

  return (
    <>
      <Button type="primary" onClick={showModal} icon={<PlusOutlined />}>{`Add ${
        multiple ? 'files' : 'file'
      }`}</Button>
      {visible && (
        <Modal
          style={{ top: 20 }}
          width={1200}
          open={visible}
          title="Uploaded Files"
          onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
          closable={!loading}
          keyboard={!loading}
          maskClosable={!loading}
        >
          <StorageFileContent
            selected={selected}
            setSelected={setSelected}
            multiple={multiple}
            accept={accept}
            isRefresh={!!visible}
            operations={operations}
            contentTypes={contentTypes}
          />
        </Modal>
      )}
    </>
  );
};

export default ExistedFilesModal;
